var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDegreeHatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 7.25L9.59315 3.75L18.3523 7.25L9.59315 10.75L0.833984 7.25Z",
    stroke: "#607238",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3531 7.2959V11.1388M4.81641 9.09382V14.278C4.81641 14.278 6.82057 16.2501 9.59391 16.2501C12.3677 16.2501 14.3718 14.278 14.3718 14.278V9.09382",
    stroke: "#607238",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegreeHatIcon);
export default __webpack_public_path__ + "static/media/degree-hat-icon.1e2e340f735110fa8a08b5bca8e67035.svg";
export { ForwardRef as ReactComponent };